import textBing from './text-bing';
import image191100AudienceWide from './image-191-100-audience-wide';
import image178100EdgeSingle from './image-178-100-edge-single';
import image150100MSNInArticle from './image-150-100-msn-in-article';
import image133100MSNSmall from './image-133-100-msn-small';
import image11AudienceSquare from './image-1-1-audience-square';
import social11Facebook from './social-1-1-facebook';

export const streamlinedSignupTemplates = [
  textBing,
  image191100AudienceWide,
  image178100EdgeSingle,
  image150100MSNInArticle,
  image133100MSNSmall,
  image11AudienceSquare,
  social11Facebook,
];
